// extracted by mini-css-extract-plugin
export var base = "typography-module--base--16985";
export var blockQuoteGreen = "typography-module--blockQuoteGreen--95d37";
export var blockQuoteLarge = "typography-module--blockQuoteLarge--4d5b6";
export var blockQuoteRed = "typography-module--blockQuoteRed--a9c34";
export var blockQuoteSymbol = "typography-module--blockQuoteSymbol--66d75";
export var blockQuoteSymbolRed = "typography-module--blockQuoteSymbolRed--bd0e4";
export var large = "typography-module--large--591f2";
export var micro = "typography-module--micro--cb01b";
export var paragraph = "typography-module--paragraph--e56c7";
export var paragraphCentered = "typography-module--paragraphCentered--f4811";
export var paragraphSans = "typography-module--paragraphSans--0fb30";
export var paragraphSansBigger = "typography-module--paragraphSansBigger--6fbb0";
export var paragraphSansMedium = "typography-module--paragraphSansMedium--1b5f1";
export var paragraphSansSmaller = "typography-module--paragraphSansSmaller--6760c";
export var responsiveTitle1 = "typography-module--responsiveTitle1--d2dd2";
export var responsiveTitle1Centered = "typography-module--responsiveTitle1Centered--a44bb";
export var responsiveTitle1Medium = "typography-module--responsiveTitle1Medium--1f97c";
export var responsiveTitle1MediumLight = "typography-module--responsiveTitle1MediumLight--017d5";
export var responsiveTitle1Sans = "typography-module--responsiveTitle1Sans--e467b";
export var responsiveTitle2 = "typography-module--responsiveTitle2--2cd97";
export var responsiveTitle2Centered = "typography-module--responsiveTitle2Centered--33160";
export var responsiveTitle2Reg = "typography-module--responsiveTitle2Reg--9345a";
export var responsiveTitle2Sans = "typography-module--responsiveTitle2Sans--acc4d";
export var responsiveTitle2SansCentered = "typography-module--responsiveTitle2SansCentered--e59b8";
export var responsiveTitle3 = "typography-module--responsiveTitle3--2bebc";
export var responsiveTitle3Centered = "typography-module--responsiveTitle3Centered--2a65f";
export var responsiveTitle3Sans = "typography-module--responsiveTitle3Sans--bed9d";
export var responsiveTitle4 = "typography-module--responsiveTitle4--45808";
export var responsiveTitle4Centered = "typography-module--responsiveTitle4Centered--64386";
export var responsiveTitle4Sans = "typography-module--responsiveTitle4Sans--7ff5d";
export var responsiveTitle5 = "typography-module--responsiveTitle5--9b75b";
export var responsiveTitle5Sans = "typography-module--responsiveTitle5Sans--eb804";
export var small = "typography-module--small--2877f";
export var smallTitle = "typography-module--smallTitle--11bd2";
export var title1 = "typography-module--title1--8f913";
export var title2 = "typography-module--title2--9ffee";
export var title3 = "typography-module--title3--c0886";
export var title4 = "typography-module--title4--78b13";